import { openModal } from "action/modal/openModal";
import { getCategory } from "api/category/category.api";
import { IWheelTires } from "api/interfaces/static-pages/wheels-tires.type";
import TiresAPI from "api/tires.api";
import PAButton, { BUTTON_SIZE } from "component/design-system/buttons/PAButton";
import CategorySection from "component/design-system/category-selection/CategorySection";
import PADescription from "component/design-system/pa-description/PADescription";
import Text, { TEXT_TYPE } from "component/design-system/typography/Text";
import ArticleGuide from "component/guide-articles/ArticleGuide";
import AffirmLogo from "component/logo/AffirmLogo";
import FlexitiLogo from "component/logo/FlexitiLogo";
import SezzleLogo from "component/logo/SezzleLogo";
import axios from "fetch-api/fetch-api";
import useScreenSize from "hoc/useScreenSize";
import { RootState } from "interfaces/generics.type";
import BannerWrapper from "modules/home/BannerWrapper";
import HomeCategory from "modules/home/category/HomeCategory";
import { DepartmentType } from "modules/home/department-constant";
import TireAndWheelSizesButton from "modules/static-pages/tire-calculator/TireAndWheelSizesButton";
import { useTranslation } from "next-i18next";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import isFeatureEnabled from "util/helper/isFeatureEnabled";
import HideIf from "util/HideIf";
import { pick } from "util/lodash/pick";
import { getPageDetails } from "util/url/apiConstants";
import { getFitmentOptionQS } from "util/vehicle/get-fitment-option-q-s";
import PageContainer from "../../components/PageContainer";
import CategoryGrid from "./category-grid";
import styles from "./styles.module.scss";

function WheelsTires(props: IWheelTires) {
  const {
    // banners,
    // brands,
    tireCategory,
    wheelCategory,
    articles,
    aboutTires,
    bannersWebp,
  } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation(["static-pages", "common"]);
  const commonT = (_: string) => t(_, { ns: "common" });

  function openVehicleSelectorModal() {
    dispatch(openModal("vehicleSelector", {}));
  }
  const [wheelDiameter, setWheelDiameter] = useState();
  const [tireSizes, setTireSizes] = useState<{ size: string }[]>();

  const selectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);
  const auth = useSelector((state: RootState) => state.authenticationState);
  const { expConfigurations } = auth;
  const isAffirmEnabled = isFeatureEnabled(expConfigurations, "affirm");
  const [isMobile] = useScreenSize();
  const router = useRouter();

  useEffect(() => {
    const fitmentOptionQS = getFitmentOptionQS(selectedVehicle?.fitmentOptions || []);
    const vehicle = { ...pick(selectedVehicle || {}, ["make", "model", "year"]) };
    TiresAPI.getAllTireSizes(selectedVehicle)
      .then(({ data }) => {
        const tireSizeResponse = data.tireSizes.map((tireSize: string) => ({
          size: tireSize,
        }));
        setTireSizes(tireSizeResponse);
      });

    axios.get(`${getPageDetails}?${fitmentOptionQS}`, {
      params: { url: "wheels-rims", ...vehicle },
    }).then(({
      data,
    }: any) => {
      const { diameters } = data.actualResponse.productsAggregation;
      const diametersValueArray = diameters.map((eachDiameter: any) => ({
        diameter: eachDiameter.bucket,
      }));
      setWheelDiameter(diametersValueArray);
    });
  }, [selectedVehicle]);

  useEffect(() => {
    // Scroll to hash after component mounts
    const hash = router.asPath.split("#")[1];
    if (hash) {
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, []);

  const mountingBenefitsArray = [t("mounting_benefits_1"), t("mounting_benefits_2"), t("mounting_benefits_3"), t("mounting_benefits_4"), t("mounting_benefits_5"), t("mounting_benefits_6")];

  return (
    <div className="home">

      <BannerWrapper
        baseImageUrl={getRelativeImagePath("/images/tires")}
        bannersWebp={bannersWebp}
      />

      <PageContainer>

        <Text size={1} bold className="text-center">
          {t("Wheels and Tires")}
        </Text>

        <div className="p-b-20">

          <div className="text-center m-t-15 m-b-15 grey-background p-20 row">

            <div className="col-md-8 col-xs-12">

              <Text
                size={3}
                bold
                className="text-left"
                style={{ lineHeight: "1.4" }}
              >
                {t("TIRE DECISION GUIDE")}

                <br />
                {t("right_tires")}
              </Text>

              <Text size={4} className="text-left" type={TEXT_TYPE.secondary}>
                {t("top_tire_recommendation")}
              </Text>
            </div>

            <div className="col-md-4 col-xs-12 d-flex align-center m-t-20">

              <PAButton
                size={BUTTON_SIZE.LARGE}
                onClick={openVehicleSelectorModal}
              >
                {t("Try Our Tire Decision Guide")}
              </PAButton>
            </div>
          </div>
        </div>

        <Text size={3} bold className="text-left p-t-20 text-center" id="shop-tire-by-category">
          {t("Shop Tire by Categories")}
        </Text>

        <CategoryGrid
          categories={tireCategory}
          departmentId={DepartmentType.WHEELS_AND_TIRES.id}
        />

        <hr style={{ borderColor: "#d7d7d7" }} />

        <Text size={3} bold className="text-left p-t-20 text-center" id="shop-wheel-by-category">
          {" "}
          {t("Shop Wheels by Categories")}
          {" "}
        </Text>

        <CategoryGrid
          categories={wheelCategory}
          departmentId={DepartmentType.WHEELS_AND_TIRES.id}
        />

        <hr style={{ borderColor: "#d7d7d7" }} />

        <Text size={3} bold className="text-left p-t-20 text-center">
          {t("Wheels & Tires Accessories")}
        </Text>

        <div className={styles.catContainer}>

          {isMobile

            ? (
              <HomeCategory
                type="list"
                departmentId={DepartmentType.WHEELS_AND_TIRES.id}
                showAllCategories
                shouldShowExtraContent={false}
                numOfRows={1}
                category={getCategory(DepartmentType.WHEELS_AND_TIRES.id)}
              />
            )
            : (
              <HomeCategory
                departmentId={DepartmentType.WHEELS_AND_TIRES.id}
                category={getCategory(DepartmentType.WHEELS_AND_TIRES.id)}
              />
            )}
        </div>

        <div className={styles.mountingSection} id="mounting-balancing">

          <div className={styles.heading}>

            <Text size={1} bold className={styles.subText_1}>

              <span className={styles.subText_2}>{`${commonT("FREE")} `}</span>
              {t("Mounting and Balancing")}
            </Text>

            <span />

          </div>

          <div className={styles.subContainer}>

            <div className={styles.description}>
              {t("free_mounting_description_1")}

              <br />
              {t("free_mounting_description_2")}
            </div>

            <div className={styles.imageSection}>

              <Image
                unoptimized
                layout="fill"
                src={getRelativeImagePath("/images/tires/mounting-min.png")}
              />
            </div>

            <div className={styles.listItem}>

              {mountingBenefitsArray.map((eachBenefit) => (
                <li key={eachBenefit}>
                  {eachBenefit}
                </li>
              ))}
            </div>

          </div>
        </div>

        <ArticleGuide href="/wiki-tires-and-wheels" articles={articles} tileWidth={240} />
        {/* <FeaturedMakeAndManufacture /> */}

        <CategorySection {...{
          title: t("Browse By Wheel Diameter"),
          categoryUrls: wheelDiameter,
        }}
        >

          <TireAndWheelSizesButton selectedVehicle={selectedVehicle} />
        </CategorySection>
        {/* <GuideAndArticles articles={articles} /> */}

        <div className="p-t-20 p-b-20">

          <Text size={3} bold className="text-left text-center">
            {t("Top brands")}
          </Text>
          {/* TODO make this image jpg (size can be reduced) and use Image component */}

          <img
            src={getRelativeImagePath("/images/tires/tire-brands.png")}
            style={{ width: "100%" }}
            alt="tire-wheels-brands"
          />
          {/* <MediaQuery minWidth={matchMediaConst.MD_MIN}>
              <div style={{ width: "auto" }}>
                <PACarousel items={brands} />
              </div>
            </MediaQuery> */}
        </div>

        <CategorySection {...{
          title: t("Browse By Tire Size"),
          categoryUrls: tireSizes,
        }}
        >

          <TireAndWheelSizesButton selectedVehicle={selectedVehicle} />
        </CategorySection>

        <div className="p-t-20 p-b-20 m-t-30">

          <div className={`text-center m-t-15 m-b-15 ${styles.grey_background} row`}>

            <div
              className={`${styles.mobileFloatImg} col-md-4 col-xs-12 d-flex align-center`}
              style={{ justifyContent: "center", top: "calc(-8.6 * var(--safari-root-font, 10px))" }}
            >

              <img
                className={styles.floatImg}
                src={getRelativeImagePath("/images/tires/rim.png")}
                alt="payments-method-rim"
              />
            </div>

            <div className="col-md-8 col-xs-12">

              <Text
                size={2}
                bold
                className="text-left"
                style={{ lineHeight: "1.4" }}
              >
                {t("Order Now")}
              </Text>

              <div className="d-flex align-items-center">

                <Text
                  size={3}
                  bold
                  className="text-left"
                  style={{ lineHeight: "1.4", margin: 0 }}
                >
                  {t("Drive now Pay later with")}
                </Text>

                <HideIf show={!isAffirmEnabled}>
                  <div className="d-flex align-items-center p-l-10">
                    <SezzleLogo />
                    <span className="p-l-5 p-r-5">{t("or")}</span>
                    <FlexitiLogo />
                  </div>
                </HideIf>
                <HideIf show={isAffirmEnabled}>
                  <div className="d-flex align-items-center p-l-10">
                    <AffirmLogo width={66} height={30} className={styles.affirm_logo} />
                  </div>
                </HideIf>
                <div className="d-flex align-items-center p-l-10">
                  <SezzleLogo />
                  <span className="p-l-5 p-r-5">{t("or")}</span>
                  <FlexitiLogo />
                  <AffirmLogo width={66} height={30} className={styles.affirm_logo} />
                </div>
              </div>
              <HideIf show={!isAffirmEnabled}>
                <Text size={4} className="text-left" type={TEXT_TYPE.secondary}>
                  {t("sezzle_description")}
                </Text>
              </HideIf>
              <HideIf show={isAffirmEnabled}>
                <Text size={4} className="text-left" type={TEXT_TYPE.secondary}>
                  {t("affirm_description")}
                </Text>
              </HideIf>

              <div className="align-left d-flex p-t-20 p-b-10">

                <PAButton
                  size={BUTTON_SIZE.LARGE}
                  style={{ width: 250 }}
                  onClick={() => router.push("/financing")}
                >
                  {t("How it works")}
                </PAButton>
              </div>
            </div>
          </div>
        </div>

        <PADescription>

          <Text
            size={4}
            className="text-left"
            type={TEXT_TYPE.secondary}
          >
            {aboutTires}
          </Text>
        </PADescription>

        <div className="p-t-20 p-b-20 m-t-30">

          <div className={`text-center m-t-15 m-b-15 ${styles.grey_background} row`}>

            <div
              className={`${styles.mobileFloatImg} col-md-4 col-xs-12 d-flex align-center`}
              style={{ justifyContent: "center", top: "calc(-6.5 * var(--safari-root-font, 10px))" }}
            >

              <img
                className={styles.floatImg}
                src={getRelativeImagePath("/images/tires/tire-cal.png")}
                alt="tire-calculator-img"
              />
            </div>

            <div className="col-md-8 col-xs-12">

              <Text
                size={2}
                bold
                className="text-left"
                style={{ lineHeight: "1.4" }}
              >
                {t("Tire Size Calculator")}
              </Text>

              <Text size={4} className="text-left" type={TEXT_TYPE.secondary}>
                {t("tire_calculator_description")}
              </Text>

              <div className="align-left d-flex p-t-20 p-b-10">

                <PAButton size={BUTTON_SIZE.LARGE} style={{ width: 250 }} onClick={() => router.push("/tire-calculator")}>
                  {t("Start now")}
                </PAButton>
              </div>
            </div>
          </div>
        </div>

        {/* <Text size={3} bold className="text-left  p-t-20 p-b-20">
            Featured Products
          </Text> */}

      </PageContainer>
    </div>
  );
}
export default memo(WheelsTires);
